import { Produtosformulario } from "./Produtosformulario";

export class RetornoProdutos {
  sucesso: boolean;
  erro: string;
  produtos: Produtosformulario;
}
